import { styled } from '@linaria/react'
import { Button } from 'atoms/Button'
import { IconSC } from 'atoms/Icon'
import { TextBoxSC } from 'atoms/TextBox'
import {
  DropdownHeaderStyled,
  DropdownItemTypeButtonStyled,
} from 'blocks/Dropdown'
import { DropdownItemsGroupStyled } from 'blocks/Dropdown/DropdownItemsGroup'
import { DropdownLanguageSC } from 'blocks/Dropdown/Templates'
import { COLOR } from 'vars/color'
import { CORNERS } from 'vars/corners'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { MEDIA } from 'vars/media'
import { PopupHeaderSC, PopupWindow } from '../Popup.styled'

export const VoiceSearchPopupSC = styled.div`
  ${PopupWindow} {
    padding: var(${FIXED_INDENTS.INDENT_20});
    width: 100vw;
    height: 100dvh;
    max-height: initial;

    ${MEDIA.MIN_600} {
      margin: 0 var(${FIXED_INDENTS.INDENT_60});
      height: 576px;
    }

    ${MEDIA.MIN_768} {
      height: 546px;
    }

    ${MEDIA.MIN_1240} {
      width: 980px;
      height: 576px;
      margin: 0;
    }

    ${MEDIA.MAX_1239_LANDSCAPE_TOUCH} {
      height: 100dvh;
      width: 100vw;
      margin: 0;
    }

    ${MEDIA.MIN_1440} {
      height: 584px;
    }
  }

  ${PopupHeaderSC} {
    flex: 1;
    display: flex;
  }
`

export const VoiceSearchContentWrapperSC = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-top: var(${FIXED_INDENTS.INDENT_160});
  margin-left: var(${FIXED_INDENTS.INDENT_40});
  margin-right: var(${FIXED_INDENTS.INDENT_40});
  margin-bottom: var(${FIXED_INDENTS.INDENT_40});
  height: 548px;

  ${MEDIA.MIN_600} {
    margin-top: var(${FIXED_INDENTS.INDENT_170});
    height: auto;
  }

  ${MEDIA.MIN_1240} {
    margin-left: var(${FIXED_INDENTS.INDENT_100});
    margin-right: var(${FIXED_INDENTS.INDENT_100});
    margin-bottom: var(${FIXED_INDENTS.INDENT_100});
  }

  ${MEDIA.MIN_1440} {
    margin-left: var(${FIXED_INDENTS.INDENT_140});
    margin-right: var(${FIXED_INDENTS.INDENT_140});
    margin-bottom: var(${FIXED_INDENTS.INDENT_140});
  }
`

export const VoiceSearchHeadSC = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(${FIXED_INDENTS.INDENT_60});

  ${MEDIA.MIN_1240} {
    gap: var(${FIXED_INDENTS.INDENT_100});
  }

  ${MEDIA.MIN_1440} {
    gap: var(${FIXED_INDENTS.INDENT_120});
  }

  ${DropdownItemTypeButtonStyled} {
    ${TextBoxSC} {
      text-transform: uppercase;
    }

    ${IconSC} {
      color: var(${COLOR.ACCENT_TERTIARY});
    }
  }

  ${DropdownHeaderStyled} {
    ${TextBoxSC} {
      text-transform: uppercase;
    }
  }

  ${DropdownItemsGroupStyled} {
    border-radius: var(${CORNERS.CORNERS_10});
  }

  ${DropdownLanguageSC} {
    margin-top: initial;
  }
`

export const VoiceSearchResultSC = styled.div`
  margin-top: var(${FIXED_INDENTS.INDENT_40});

  ${MEDIA.MIN_600} {
    margin-top: var(${FIXED_INDENTS.INDENT_50});
  }

  ${MEDIA.MIN_1240} {
    margin-top: var(${FIXED_INDENTS.INDENT_60});
  }

  ${MEDIA.MAX_1239_LANDSCAPE_TOUCH} {
    ${TextBoxSC} {
      -webkit-line-clamp: 2;
    }
  }
`

export const VoiceSearchFooterButtonSC = styled(Button)``

export const VoiceSearchFooterSC = styled.div`
  margin-top: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 262px;

  ${MEDIA.MAX_1239_LANDSCAPE_TOUCH} {
    height: 161px;
  }

  ${VoiceSearchFooterButtonSC}[data-arcana-button='true'] {
    background-color: var(${COLOR.SURFACE_OPACITY_LIGHT_10});
    border-radius: 50%;
    width: 84px;
    height: 84px;
  }
`

export const VoiceSearchLoaderSC = styled.div<{
  size: number
  strokeWidth: number
  mainColor: COLOR
  accentColor: COLOR
}>`
  --size: ${({ size }) => `${size}px`};
  --borderWidth: ${({ strokeWidth }) => `${strokeWidth}px`};
  position: relative;
  margin-right: 8px;

  border-width: var(--borderWidth);
  border-color: ${({ mainColor }) => `var(${mainColor})`};
  border-style: solid;
  border-left-color: ${({ accentColor }) => `var(${accentColor})`};
  -webkit-animation: loader 1.1s infinite ease-in-out;
  animation: loader 1.1s infinite ease-in-out;
  border-radius: 50%;
  width: var(--size);
  height: var(--size);

  &:after {
    border-radius: 50%;
    width: var(--size);
    height: var(--size);
  }

  @keyframes loader {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
`
